import * as React from 'react';
import { DirectoryStoreState } from '../../types';
import { getPreloadedStore } from '../../reducers/stores';
import { useMappedState } from 'redux-react-hook';
import { useCallback } from 'react';
import { SearchBar } from '../SearchBar';
import { SortOrderPanel } from '../SortOrder';
import { StoresList } from '../StoresList';
import { StorePreloaded } from '../StorePreloaded';
import { Suspense } from 'react';
const NotFoundStore = React.lazy(() => import('../StorePreloaded/NotFound'));

export interface MainProps {}

export const Main: React.FC<MainProps> = () => {
  const { preloadedStore, slocQueryString } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        preloadedStore: getPreloadedStore(state),
        slocQueryString: state.queryString.sloc,
      }),
      []
    )
  );

  return slocQueryString ? (
    <React.Fragment>
      {preloadedStore ? (
        <StorePreloaded store={preloadedStore} />
      ) : (
        <Suspense fallback={<div />}>
          <NotFoundStore />
        </Suspense>
      )}
    </React.Fragment>
  ) : (
    <React.Fragment>
      <SearchBar />
      <SortOrderPanel />
      <StoresList />
    </React.Fragment>
  );
};
